var _a;
import { __decorate, __metadata, __param } from "tslib";
import { TaggingSettingModel } from '../models/tagging-setting-model.interface';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
let TaggingSettingServiceImpl = class TaggingSettingServiceImpl {
    constructor(_taggingSettingModel) {
        this._taggingSettingModel = _taggingSettingModel;
    }
    updateTaggingType(taggingType) {
        this._taggingSettingModel.updateTaggingType(taggingType);
    }
    updateThreshold(threshold) {
        this._taggingSettingModel.updateThreshold(threshold);
    }
    updateReadScope(dataScope) {
        this._taggingSettingModel.updateReadScope(dataScope);
    }
    updateAiModel(aiModel) {
        this._taggingSettingModel.updateAiModel(aiModel);
    }
    getSettingData() {
        return this._taggingSettingModel.taggingSetting;
    }
    subscribeTaggingSettingData(callback) {
        return this._taggingSettingModel.onStatesChange(callback);
    }
};
TaggingSettingServiceImpl = __decorate([
    injectable(),
    __param(0, inject(TaggingSettingModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof TaggingSettingModel !== "undefined" && TaggingSettingModel) === "function" ? _a : Object])
], TaggingSettingServiceImpl);
export { TaggingSettingServiceImpl };
